import { createFileRoute } from "@tanstack/react-router";
import { ResetPasswordPage } from "@/modules/auth/presentation/pages/ResetPasswordPage";

export const Route = createFileRoute("/reset-password")({
  component: ResetPasswordPage,
});
